import { useMemo } from 'react'

import { PostalCodeTarget } from 'api/interfaces'
import { AIPlanCampaignBuilder, AIPlanCampaignBuilderType, AIPlanStub } from 'api/interfaces/AIPlan'

export const useAIPlanZipCodesByType = (stub: AIPlanStub | undefined, campaignTypes: AIPlanCampaignBuilderType[]): string[] => {
  return useMemo((): string[] => {
    if (!stub?.campaignBuilders) {
      return []
    }

    const allZips: Set<string> = new Set()
    stub.campaignBuilders.forEach(campaign => {
      if (!campaign.zips || !campaignTypes.includes(campaign.campaignType)) {
        return
      }

      campaign.zips.forEach((zip: PostalCodeTarget) => {
        if (zip.code) {
          allZips.add(zip.code)
        }
      })
    })

    return Array.from(allZips)
  }, [stub])
}

export const useAIPlanBillboardZipCodes = (stub: AIPlanStub | undefined): string[] => {
  return useAIPlanZipCodesByType(stub, [AIPlanCampaignBuilderType.Billboard])
}

export const useAIPlanHouseholdZipCodes = (stub: AIPlanStub | undefined): string[] => {
  return useMemo((): string[] => {
    if (!stub?.campaignBuilders) {
      return []
    }

    const allZips: Set<string> = new Set()
    stub.campaignBuilders.forEach(campaign => {
      if (!campaign.zips) {
        return
      }

      const isInternet = campaign.campaignType === AIPlanCampaignBuilderType.Internet
      const isTV = campaign.campaignType === AIPlanCampaignBuilderType.TV
      const isOffAdCritterWithProjectionsAndGeoHeatmap = campaign.campaignType === AIPlanCampaignBuilderType.OffAdCritter && campaign.includeInProjections && campaign.includeInGeoHeatmap

      if (!isInternet && !isTV && !isOffAdCritterWithProjectionsAndGeoHeatmap) {
        return
      }

      campaign.zips.forEach((zip: PostalCodeTarget) => {
        if (zip.code) {
          allZips.add(zip.code)
        }
      })
    })

    return Array.from(allZips)
  }, [stub])
}
